import { useRouter } from 'next/router'
import React, { memo, useContext } from 'react'

import HeapAnalytics from '@/components/users/shared/integration_snippets/HeapAnalytics'
import Segment from '@/components/users/shared/integration_snippets/Segment'
import HNContext from '@/context/HNContext'
import type {
  IOrganizationData,
  IOrganizationSetting,
} from '@/types/organization'
import type { IUserProfile } from '@/types/user'

import FathomAnalytics from './FathomAnalytics'
import FullStory from './FullStory'
import GoogleAnalytics from './GoogleAnalytics'
import PlausibleAnalytics from './PlausibleAnalytics'

function Snippets() {
  const { organization, organizationSetting } = useContext(HNContext) as {
    organization: IOrganizationData
    organizationSetting: IOrganizationSetting
    userProfile: IUserProfile
  }
  const router = useRouter()
  if (!organization || !organizationSetting) return null

  if (
    !router.pathname.includes('/admin') &&
    !router.pathname.includes('/embed') &&
    !router.pathname.includes('/postwidget') &&
    !router.pathname.includes('/submission_only') &&
    !router.pathname.includes('/changelogwidget') &&
    !router.pathname.includes('/submission_form_with_key')
  ) {
    return (
      <>
        <Segment segmentKey={organizationSetting.segment_id} />
        <GoogleAnalytics
          trackingId={organizationSetting.google_analytics_app_id || ``}
        />
        <PlausibleAnalytics
          domain={organizationSetting.plausible_domain || ``}
        />
        <FathomAnalytics siteId={organizationSetting.fathom_site_id || ``} />
        <FullStory appId={organizationSetting.fullstory_app_id || ``} />
        <HeapAnalytics appId={organizationSetting.heap_app_id || ``} />
      </>
    )
  }
  return null
}

export default memo(Snippets)
